export class UnifiedUserApi {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * List both users and candidate chat users
     * @returns UnifiedUser
     * @throws ApiError
     */
    listUnifiedUsers() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/unified-user',
        });
    }
    /**
     * Delete a user or chat user
     * @returns any
     * @throws ApiError
     */
    deleteUnifiedUser({ type, id, }) {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/unified-user',
            query: {
                'type': type,
                'id': id,
            },
        });
    }
    /**
     * Masquerade as a user
     * @returns MasqueradeAsUserResponse
     * @throws ApiError
     */
    masqueradeAsUser({ requestBody, }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/unified-user/masquerade',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
